// Length of the animation in milliseconds
export var ANIMATION_LENGTH = 1500;
// Interval in milliseconds between animation repeats
export var ANIMATION_REPEAT_INTERVAL = 500;
// Maximum number of animation repeats
export var MAX_REPEATS = 10;
//# sourceMappingURL=config.js.map